import Vue from 'vue'
import Vuetify from 'vuetify'
import VuetifyDialog from 'vuetify-dialog';
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify)

const vuetify = new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#BDBDBD',
                secondary: '#424242',
                accent: '#BDBDBD',
                error: '#FF5252',
                info: '#2196F3',
                success: '#4CAF50',
                warning: '#FFC107'
            }
        }
    }
});

Vue.use(VuetifyDialog, {
    context: {
        vuetify,
    },
});

export default vuetify;
